<template>
	<ModalGenericModal
		:title="title"
		container-class="rounded-lg w-full md:w-11/12"
		ref="baseModal">
		<div
			class="p-2 h-[80vh] md:h-[83vh] bg-popup-bg border-x-2 border-b-2 border-popup-border text-popup-text rounded-b-lg flex flex-col gap-4 text-center">
			<p class="basis-xs mt-2">{{ body }}</p>

			<div class="text-right">
				<ButtonIconThenText
					class="text-ternary text-xs hoverEffects viewDetails"
					:text="showHelp ? $t('helpHide') : $t('helpShow')"
					icon="fa-solid fa-circle-info"
					@clicked="expandHelp" />
			</div>

			<transition name="slide-fade">
				<div
					v-if="showHelp"
					class="text-sm text-left"
					:class="{ 'leading-3': !$utilities.$isMobileDevice() }">
					<div v-html="$utilities.$isMobileDevice() ? t('previewHelpMobile') : t('previewHelpDesktop')"></div>
				</div>
			</transition>

			<div class="max-w-5/6 max-h-5/6 mx-auto my-auto grow bg-black/5 flex justify-center items-center">
				<img
					ref="imageRef"
					:src="imageSrc"
					alt="map" />
			</div>

			<div class="basis-xs">
				<ButtonModalClose
					:label="$t('close')"
					class="w-32"
					@click="closeModal" />
			</div>
		</div>
	</ModalGenericModal>
</template>

<script setup>
	import Panzoom from "@panzoom/panzoom"

	const { t } = useI18n()
	const { $utilities } = useNuxtApp()

	defineProps({
		title: String,
		body: String,
		imageSrc: String,
	})

	const baseModal = ref(null)
	const showHelp = ref(false)
	const imageRef = ref(null)
	const panzoomInstance = ref(null)

	const expandHelp = () => {
		showHelp.value = !showHelp.value
	}

	const openModal = () => {
		baseModal.value?.openModal()
		nextTick(() => {
			const elem = imageRef.value
			panzoomInstance.value = Panzoom(elem, {
				maxScale: 3,
				minScale: 0.5,
			})
			elem.parentElement.addEventListener("wheel", panzoomInstance.value.zoomWithWheel, { passive: false })
		})
	}

	const closeModal = () => {
		baseModal.value?.closeModal()
		// Clean up all Panzoom resources
		if (panzoomInstance.value) {
			panzoomInstance.value.destroy?.()
			panzoomInstance.value = null
		}
	}

	defineExpose({
		openModal,
	})
</script>

<style lang="scss" scoped></style>
